import { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import PlanUpgradeModal from "../pages/SubscriptionSetup/PlanUpgradeModal";

const PlanProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // State for Modal and Redirect Logic
  const [showModal, setShowModal] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false); // New state for redirect
  const [isChecking, setIsChecking] = useState(true);
  const [userPlanId, setUserPlanId] = useState(null);

  // Check Plan on Mount
  useEffect(() => {
    try {
      const restaurantData = localStorage.getItem("restaurant");
      if (restaurantData) {
        const restaurantObj = JSON.parse(restaurantData);
        setUserPlanId(restaurantObj.FMlYe6C || 0);
      } else {
        setUserPlanId(0);
      }
    } catch (error) {
      console.error("Error parsing restaurant data", error);
      setUserPlanId(0);
    } finally {
      setIsChecking(false);
    }
  }, []);

  // Show Modal automatically if Basic Plan
  useEffect(() => {
    if (
      !isChecking &&
      (userPlanId === 4 || userPlanId === "4" || userPlanId === 0)
    ) {
      // Small delay to ensure smooth mount
      const timer = setTimeout(() => setShowModal(true), 100);
      return () => clearTimeout(timer);
    }
  }, [isChecking, userPlanId]);

  // Loading State
  if (isChecking) {
    return null;
  }

  // Determine if Basic Plan OR No Plan
  const isBasicPlan =
    userPlanId === 4 || userPlanId === "4" || userPlanId === 0;

  // If Basic Plan, Render Modal + Redirect Logic
  if (isBasicPlan) {
    // If the "Maybe Later" button was clicked, redirect to Home
    if (shouldRedirect) {
      return (
        <Navigate
          to="/"
          state={{
            from: location,
            message: "This feature is not available in your current plan.",
          }}
          replace
        />
      );
    }

    return (
      <>
        <PlanUpgradeModal
          open={showModal}
          onClose={() => {
            setShowModal(false);
            setShouldRedirect(true); // Trigger the redirect on next render
          }}
          onUpgrade={() => {
            // Navigate to Subscription Page, passing the current location to return later
            navigate("/manage-subscription-plan", {
              state: {
                from: location.pathname,
                message: "Upgrade required for this feature.",
              },
            });
          }}
          featureName="This feature"
        />
      </>
    );
  }

  // If Premium Plan, Render Children
  return children;
};

export default PlanProtectedRoute;
